import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetItemType = createAsyncThunk(
  "WPBItemType/GetItemType",
  async (parameters, { rejectWithValue }) => {
    console.log(parameters,"makejjejjejej");
    
    try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
            "api/DropDowns/GetAllSU_ST_WPB_ItemType",
            parameters
          );

          const data = response.data.result; // Assuming response has a "data" field
          return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);





const ItemTypeReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    ItemType: {},
    loadingItemType: false,
    errorItemType: null,


  },
  reducers: {
   

  },
  extraReducers: (builder) => {
    builder
      .addCase(GetItemType.pending, (state, action) => {
        state.loadingItemType = true;
        state.ItemType = action.payload;
        state.errorItemType = null;
      })
      .addCase(GetItemType.fulfilled, (state, action) => {
        state.loadingItemType = false;
        state.ItemType = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetItemType.rejected, (state, action) => {
        state.loadingItemType = false;
        state.errorItemType = action.payload;
      });


  },
});







export default ItemTypeReducers.reducer;
